import type { LinkProps } from '@mui/material/Link';

import * as styles from './index.css';
import { ArrowLeft as ArrowLeftIcon } from '@phosphor-icons/react';
import { Link as RouterLink } from 'react-router-dom';
import { TrackedLink } from '@blueshift-ui/analytics';

interface BreadcrumbLinkProps extends LinkProps {
  id: string;
  to?: string;
}

function BreadcrumbLink({ children, ...linkProps }: BreadcrumbLinkProps) {
  return (
    <span className={styles.linkContainer}>
      <ArrowLeftIcon weight="bold" />

      <TrackedLink {...linkProps} component={linkProps?.to ? RouterLink : 'a'}>
        {children}
      </TrackedLink>
    </span>
  );
}

export default BreadcrumbLink;
